import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';

ReactDOM.render(<App />, document.getElementById('root'));

/*
document.addEventListener(
  'deviceready',
  () => {
    if (AdMob) {
      let adId;
      if (/(android)/i.test(navigator.userAgent)) {
        adId = 'ca-app-pub-8110960198228694/9262181463';
      } else if (/(ipod|iphone|ipad)/i.test(navigator.userAgent)) {
        adId = 'ca-app-pub-8110960198228694/2771034541';
      }
      AdMob.createBanner({
        adId: adId,
        position: AdMob.AD_POSITION.BOTTOM_CENTER,
        autoShow: true
      });
    }
  },
  false
);
*/


// WEBPACK FOOTER //
// ./src/index.js